import { InterpolateType } from './weather.model';

export type WeatherModelInitConfig = {
  layerIdList?: string[];
  visible?: boolean;
  interpolate?: InterpolateType;
  chartEnabled?: boolean;
};
